import { onMount, For, Show, createSignal } from "solid-js";
import { Ad } from "../../library/types";
import { Img } from "../universal/image";

export const Ads = () => {
    const [ads, setAds] = createSignal<Ad[]>([]);
    const loadAds = async () => {
        const response = await fetch("/Home/GetAdsJson");
        const json = await response.json();
        if (!json.Success) {
            return;
        }
        setAds(json.Data);
    };
    onMount(() => {
        loadAds();
    });
    return (
    <>
        <div style="margin-top: 40px;">
            <div>
            <For each={ads()}>{(item) =>
                <div class="slide" style="margin-bottom: 10px;">
                    <a href={item.URL}>
                        <figure>
                            <Img src={item.PrimaryImage.URL} format="jpg" width={1000} mode="crop" style="width: 100%;" />
                            <Show when={item.Text}>
                                <figcaption innerHTML={item.Text}></figcaption>
                            </Show>
                        </figure>
                    </a>
                </div>
            }</For>                                
            </div>
        </div>
    </>
    )
}
